import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useForm } from 'react-hook-form';
import './Auth.css';


function DonorLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  async function onSubmit(data) {
  try {
    setError('');
    setLoading(true);

    const userCredential = await signInWithEmailAndPassword(
      auth,
      data.email,
      data.password
    );

    const user = userCredential.user;

    const donorDoc = await getDoc(doc(db, 'donors', user.uid));

    if (!donorDoc.exists()) {
      await signOut(auth);
      setError('No donor account found with this email.');
      return;
    }

    navigate('/give/dashboard');
  } catch (err) {
    setError(getErrorMessage(err.code));
  } finally {
    setLoading(false);
  }
}

  function getErrorMessage(code) {
    switch(code) {
      case 'auth/user-not-found':
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
        return 'Invalid email or password.';
      case 'auth/too-many-requests':
        return 'Too many attempts. Please try again later.';
      default:
        return 'Something went wrong. Please try again.';
    }
  }

async function handlePasswordReset() {
  const email = window.prompt('Enter your email address:');
  if (!email) return;

  try {
    await sendPasswordResetEmail(auth, email);
    alert('Password reset email sent.');
  } catch (err) {
    console.error(err);
    alert('Could not send password reset email.');
  }
}

  return (
    <div className="auth-page">
      <div className="auth-card">

        <div className="auth-logo" onClick={() => navigate('/')}>
          somebody.gives
        </div>

        <h1>Welcome back</h1>
        <p className="auth-sub">
          Sign in to manage your commitments and see your impact.
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit(onSubmit)} className="auth-form">

          <div className="form-group">
            <label>Email address</label>
            <input
              {...register('email', {
                required: 'Email is required',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Please enter a valid email'
                }
              })}
              placeholder="your@email.com"
              type="email"
            />
            {errors.email &&
              <span className="field-error">{errors.email.message}</span>}
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              {...register('password', {
                required: 'Password is required'
              })}
              placeholder="Your password"
              type="password"
            />
            {errors.password &&
              <span className="field-error">{errors.password.message}</span>}
          </div>

          <span onClick={handlePasswordReset}>
  Forgot your password?
</span>


          <button
            type="submit"
            className="btn-primary btn-full"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign in →'}
          </button>

        </form>

        <div className="auth-footer">
          Don't have an account?{' '}
          <span onClick={() => navigate('/give/signup')}>
            Create one
          </span>
        </div>

        <div className="org-link">
          Are you a nonprofit?{' '}
          <span onClick={() => navigate('/org/login')}>
            Sign in here
          </span>
        </div>

      </div>
    </div>
  );
}

export default DonorLogin;